<div class="nav-header navbar fixed-top desktop">
  <div class="container nav-container">

    <!-- LOGO -->
    <a routerLink="/" class="navbar-brand logo-container">
      <img
        src="../../assets/images/logo-tc-brokers.svg"
        alt="TC Brokers"
        class="logo"
      />
    </a>

    <div class="nav-right">

      <!-- PERSONAS / EMPRESAS -->
      <div class="switch-personas-empresas">

        <a
          routerLink="/"
          class="switch-option"
          [class.active]="!isEmpresas"
          (click)="seleccionarTipo('personas')">
          Personas
        </a>

        <a
          routerLink="/empresas"
          class="switch-option"
          [class.active]="isEmpresas"
          (click)="seleccionarTipo('empresas')">
          Empresas
        </a>

      </div>

      <!-- MENÚ -->
      <ul class="nav nav-header-items">

        <!-- INICIO -->
        <li class="nav-item">
          <a
            routerLink="/"
            class="menu-a">
            Inicio
          </a>
        </li>

        <!-- SEGUROS -->
        <li class="nav-item">
          <a
            [routerLink]="isEmpresas
              ? '/servicios/seguros-corporativos'
              : '/servicios/seguros-individuales'"
            class="menu-a">

            {{ isEmpresas
              ? 'Seguros corporativos'
              : 'Seguros individuales'
            }}

          </a>
        </li>

        <!-- SINIESTROS -->
        <li class="nav-item dropdown" ngbDropdown>

          <a
            class="menu-a dropdown-toggle"
            ngbDropdownToggle>
            Siniestros
          </a>

          <ul
            ngbDropdownMenu
            class="dropdown-menu">

            <li>
              <a
                routerLink="/servicios/procedimiento-para-siniestros/generales"
                class="dropdown-item color-red py-2">
                Siniestros Generales
              </a>
            </li>

            <li>
              <a
                routerLink="/servicios/procedimiento-para-siniestros/automotor"
                class="dropdown-item color-red py-2">
                Siniestro Automotor
              </a>
            </li>

            <li>
              <a
                routerLink="/servicios/seguimiento-de-siniestros"
                class="dropdown-item color-red py-2">
                Seguimiento de Siniestros
              </a>
            </li>

          </ul>

        </li>

        <!-- SUCURSALES -->
        <li class="nav-item">
          <a
            routerLink="/sucursales"
            class="menu-a">
            Sucursales
          </a>
        </li>

        <!-- INGRESAR -->
        <li
          class="nav-item"
          *ngIf="!user">

          <a
            routerLink="/login"
            class="menu-a">
            Ingresar
          </a>

        </li>

        <!-- MI CUENTA -->
        <li
          class="nav-item dropdown"
          ngbDropdown
          *ngIf="user">

          <a
            class="menu-a dropdown-toggle"
            ngbDropdownToggle>
            Mi cuenta
          </a>

          <ul
            ngbDropdownMenu
            class="dropdown-menu">

            <li>
              <a
                routerLink="/perfil"
                class="dropdown-item color-red py-2">
                Ver perfil
              </a>
            </li>

            <li>
              <a
                class="dropdown-item color-red py-2"
                (click)="salir()">
                Salir
              </a>
            </li>

          </ul>

        </li>

      </ul>

      <!-- TELÉFONO -->
      <div class="telefono">
        +591 800 10 1727
      </div>

      <!-- BUSCADOR -->
      <button
        type="button"
        class="search-button"
        (click)="abrirBuscador()"
        aria-label="Buscar">

        <i class="bi bi-search"></i>

      </button>

    </div>

  </div>
</div>

<app-mobile class="mobile"></app-mobile>